// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { SpecificationConformance } from "./SpecificationConformance";
import {
  SpecificationConformanceFromJSON,
  SpecificationConformanceFromJSONTyped,
  SpecificationConformanceToJSON,
  SpecificationConformanceToJSONTyped,
} from "./SpecificationConformance";
import type { ResourceIdentifier } from "./ResourceIdentifier";
import {
  ResourceIdentifierFromJSON,
  ResourceIdentifierFromJSONTyped,
  ResourceIdentifierToJSON,
  ResourceIdentifierToJSONTyped,
} from "./ResourceIdentifier";
import type { Keywords } from "./Keywords";
import {
  KeywordsFromJSON,
  KeywordsFromJSONTyped,
  KeywordsToJSON,
  KeywordsToJSONTyped,
} from "./Keywords";
import type { MultilingualStringWithLink } from "./MultilingualStringWithLink";
import {
  MultilingualStringWithLinkFromJSON,
  MultilingualStringWithLinkFromJSONTyped,
  MultilingualStringWithLinkToJSON,
  MultilingualStringWithLinkToJSONTyped,
} from "./MultilingualStringWithLink";
import type { ResourceDate } from "./ResourceDate";
import {
  ResourceDateFromJSON,
  ResourceDateFromJSONTyped,
  ResourceDateToJSON,
  ResourceDateToJSONTyped,
} from "./ResourceDate";
import type { CodelistItem } from "./CodelistItem";
import {
  CodelistItemFromJSON,
  CodelistItemFromJSONTyped,
  CodelistItemToJSON,
  CodelistItemToJSONTyped,
} from "./CodelistItem";
import type { ContactInfo } from "./ContactInfo";
import {
  ContactInfoFromJSON,
  ContactInfoFromJSONTyped,
  ContactInfoToJSON,
  ContactInfoToJSONTyped,
} from "./ContactInfo";
import type { OnlineLink } from "./OnlineLink";
import {
  OnlineLinkFromJSON,
  OnlineLinkFromJSONTyped,
  OnlineLinkToJSON,
  OnlineLinkToJSONTyped,
} from "./OnlineLink";
import type { Overview } from "./Overview";
import {
  OverviewFromJSON,
  OverviewFromJSONTyped,
  OverviewToJSON,
  OverviewToJSONTyped,
} from "./Overview";
import type { MultilingualString } from "./MultilingualString";
import {
  MultilingualStringFromJSON,
  MultilingualStringFromJSONTyped,
  MultilingualStringToJSON,
  MultilingualStringToJSONTyped,
} from "./MultilingualString";
import type { ResourceTemporalRange } from "./ResourceTemporalRange";
import {
  ResourceTemporalRangeFromJSON,
  ResourceTemporalRangeFromJSONTyped,
  ResourceTemporalRangeToJSON,
  ResourceTemporalRangeToJSONTyped,
} from "./ResourceTemporalRange";
import type { CrsDetail } from "./CrsDetail";
import {
  CrsDetailFromJSON,
  CrsDetailFromJSONTyped,
  CrsDetailToJSON,
  CrsDetailToJSONTyped,
} from "./CrsDetail";

/**
 * Model closely mimicing the Geonetwork search response
 * @export
 * @interface Dataset
 */
export interface Dataset {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  tenant: string | null;
  /**
   *
   */
  envelope?: Array<Array<number>>;
  /**
   *
   */
  docType?: DatasetDocTypeEnum;
  /**
   *
   */
  standardNameObject: MultilingualString;
  /**
   *
   */
  standardVersionObject: MultilingualString;
  /**
   *
   */
  dateStamp: Date;
  /**
   *
   */
  mainLanguage: string;
  /**
   *
   */
  resourceType?: Array<string>;
  /**
   *
   */
  contact?: Array<ContactInfo>;
  /**
   *
   */
  clStatus?: Array<CodelistItem>;
  /**
   *
   */
  clMaintenanceAndUpdateFrequency?: Array<CodelistItem>;
  /**
   *
   */
  clAccessConstraints?: Array<CodelistItem>;
  /**
   *
   */
  clClassification?: Array<CodelistItem>;
  /**
   *
   */
  clSpatialRepresentationType?: Array<CodelistItem>;
  /**
   *
   */
  clFunction?: Array<CodelistItem>;
  /**
   *
   */
  resourceTitleObject: MultilingualString;
  /**
   *
   */
  resourceDate?: Array<ResourceDate>;
  /**
   *
   */
  resourceTemporalDateRange?: Array<ResourceTemporalRange>;
  /**
   *
   */
  resourceIdentifier?: Array<ResourceIdentifier>;
  /**
   *
   */
  resourceAbstractObject?: MultilingualString | null;
  /**
   *
   */
  clResourceCharacterSet?: Array<CodelistItem>;
  /**
   *
   */
  contactForResource?: Array<ContactInfo>;
  /**
   *
   */
  resourceLanguage?: Array<string>;
  /**
   *
   */
  allKeywords?: { [key: string]: Keywords };
  /**
   *
   */
  clTopic?: Array<CodelistItem>;
  /**
   *
   */
  resolutionScaleDenominator?: Array<string>;
  /**
   *
   */
  resolutionDistance?: Array<string>;
  /**
   *
   */
  licenseObject?: Array<MultilingualStringWithLink>;
  /**
   *
   */
  mDConstraintsUseLimitationObject?: Array<MultilingualString>;
  /**
   *
   */
  extentIdentifierObject?: Array<MultilingualString>;
  /**
   *
   */
  crsDetails?: Array<CrsDetail>;
  /**
   *
   */
  specificationConformance?: Array<SpecificationConformance>;
  /**
   *
   */
  lineageObject?: MultilingualString | null;
  /**
   *
   */
  format?: Array<string>;
  /**
   *
   */
  contactForDistribution?: Array<ContactInfo>;
  /**
   *
   */
  link?: Array<OnlineLink>;
  /**
   *
   */
  popularity?: number;
  /**
   *
   */
  logo?: string | null;
  /**
   *
   */
  documentStandard: string;
  /**
   *
   */
  isHarvested: boolean;
  /**
   *
   */
  sourceCatalogue: string;
  /**
   *
   */
  overview?: Array<Overview>;
}

/**
 * @export
 */
export const DatasetDocTypeEnum = {
  Metadata: "metadata",
} as const;
export type DatasetDocTypeEnum = (typeof DatasetDocTypeEnum)[keyof typeof DatasetDocTypeEnum];

/**
 * Check if a given object implements the Dataset interface.
 */
export function instanceOfDataset(value: object): value is Dataset {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("tenant" in value) || value["tenant"] === undefined) return false;
  if (!("standardNameObject" in value) || value["standardNameObject"] === undefined) return false;
  if (!("standardVersionObject" in value) || value["standardVersionObject"] === undefined)
    return false;
  if (!("dateStamp" in value) || value["dateStamp"] === undefined) return false;
  if (!("mainLanguage" in value) || value["mainLanguage"] === undefined) return false;
  if (!("resourceTitleObject" in value) || value["resourceTitleObject"] === undefined) return false;
  if (!("documentStandard" in value) || value["documentStandard"] === undefined) return false;
  if (!("isHarvested" in value) || value["isHarvested"] === undefined) return false;
  if (!("sourceCatalogue" in value) || value["sourceCatalogue"] === undefined) return false;
  return true;
}

export function DatasetFromJSON(json: any): Dataset {
  return DatasetFromJSONTyped(json, false);
}

export function DatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Dataset {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    tenant: json["tenant"],
    envelope: json["envelope"] == null ? undefined : json["envelope"],
    docType: json["docType"] == null ? undefined : json["docType"],
    standardNameObject: MultilingualStringFromJSON(json["standardNameObject"]),
    standardVersionObject: MultilingualStringFromJSON(json["standardVersionObject"]),
    dateStamp: json["dateStamp"] == null ? json["dateStamp"] : parseDateTime(json["dateStamp"]),
    mainLanguage: json["mainLanguage"],
    resourceType: json["resourceType"] == null ? undefined : json["resourceType"],
    contact:
      json["contact"] == null
        ? undefined
        : (json["contact"] as Array<any>).map(ContactInfoFromJSON),
    clStatus:
      json["cl_status"] == null
        ? undefined
        : (json["cl_status"] as Array<any>).map(CodelistItemFromJSON),
    clMaintenanceAndUpdateFrequency:
      json["cl_maintenanceAndUpdateFrequency"] == null
        ? undefined
        : (json["cl_maintenanceAndUpdateFrequency"] as Array<any>).map(CodelistItemFromJSON),
    clAccessConstraints:
      json["cl_accessConstraints"] == null
        ? undefined
        : (json["cl_accessConstraints"] as Array<any>).map(CodelistItemFromJSON),
    clClassification:
      json["cl_classification"] == null
        ? undefined
        : (json["cl_classification"] as Array<any>).map(CodelistItemFromJSON),
    clSpatialRepresentationType:
      json["cl_spatialRepresentationType"] == null
        ? undefined
        : (json["cl_spatialRepresentationType"] as Array<any>).map(CodelistItemFromJSON),
    clFunction:
      json["cl_function"] == null
        ? undefined
        : (json["cl_function"] as Array<any>).map(CodelistItemFromJSON),
    resourceTitleObject: MultilingualStringFromJSON(json["resourceTitleObject"]),
    resourceDate:
      json["resourceDate"] == null
        ? undefined
        : (json["resourceDate"] as Array<any>).map(ResourceDateFromJSON),
    resourceTemporalDateRange:
      json["resourceTemporalDateRange"] == null
        ? undefined
        : (json["resourceTemporalDateRange"] as Array<any>).map(ResourceTemporalRangeFromJSON),
    resourceIdentifier:
      json["resourceIdentifier"] == null
        ? undefined
        : (json["resourceIdentifier"] as Array<any>).map(ResourceIdentifierFromJSON),
    resourceAbstractObject:
      json["resourceAbstractObject"] === undefined
        ? undefined
        : json["resourceAbstractObject"] === null
        ? null
        : MultilingualStringFromJSON(json["resourceAbstractObject"]),
    clResourceCharacterSet:
      json["cl_resourceCharacterSet"] == null
        ? undefined
        : (json["cl_resourceCharacterSet"] as Array<any>).map(CodelistItemFromJSON),
    contactForResource:
      json["contactForResource"] == null
        ? undefined
        : (json["contactForResource"] as Array<any>).map(ContactInfoFromJSON),
    resourceLanguage: json["resourceLanguage"] == null ? undefined : json["resourceLanguage"],
    allKeywords:
      json["allKeywords"] == null ? undefined : mapValues(json["allKeywords"], KeywordsFromJSON),
    clTopic:
      json["cl_topic"] == null
        ? undefined
        : (json["cl_topic"] as Array<any>).map(CodelistItemFromJSON),
    resolutionScaleDenominator:
      json["resolutionScaleDenominator"] == null ? undefined : json["resolutionScaleDenominator"],
    resolutionDistance: json["resolutionDistance"] == null ? undefined : json["resolutionDistance"],
    licenseObject:
      json["licenseObject"] == null
        ? undefined
        : (json["licenseObject"] as Array<any>).map(MultilingualStringWithLinkFromJSON),
    mDConstraintsUseLimitationObject:
      json["MD_ConstraintsUseLimitationObject"] == null
        ? undefined
        : (json["MD_ConstraintsUseLimitationObject"] as Array<any>).map(MultilingualStringFromJSON),
    extentIdentifierObject:
      json["extentIdentifierObject"] == null
        ? undefined
        : (json["extentIdentifierObject"] as Array<any>).map(MultilingualStringFromJSON),
    crsDetails:
      json["crsDetails"] == null
        ? undefined
        : (json["crsDetails"] as Array<any>).map(CrsDetailFromJSON),
    specificationConformance:
      json["specificationConformance"] == null
        ? undefined
        : (json["specificationConformance"] as Array<any>).map(SpecificationConformanceFromJSON),
    lineageObject:
      json["lineageObject"] === undefined
        ? undefined
        : json["lineageObject"] === null
        ? null
        : MultilingualStringFromJSON(json["lineageObject"]),
    format: json["format"] == null ? undefined : json["format"],
    contactForDistribution:
      json["contactForDistribution"] == null
        ? undefined
        : (json["contactForDistribution"] as Array<any>).map(ContactInfoFromJSON),
    link: json["link"] == null ? undefined : (json["link"] as Array<any>).map(OnlineLinkFromJSON),
    popularity: json["popularity"] == null ? undefined : json["popularity"],
    logo: json["logo"] === undefined ? undefined : json["logo"] === null ? null : json["logo"],
    documentStandard: json["documentStandard"],
    isHarvested: json["isHarvested"],
    sourceCatalogue: json["sourceCatalogue"],
    overview:
      json["overview"] == null ? undefined : (json["overview"] as Array<any>).map(OverviewFromJSON),
  };
}

export function DatasetToJSON(json: any): Dataset {
  return DatasetToJSONTyped(json, false);
}

export function DatasetToJSONTyped(
  value?: Dataset | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    tenant: value["tenant"],
    envelope: value["envelope"],
    docType: value["docType"],
    standardNameObject: MultilingualStringToJSON(value["standardNameObject"]),
    standardVersionObject: MultilingualStringToJSON(value["standardVersionObject"]),
    dateStamp:
      value["dateStamp"] == null ? value["dateStamp"] : serializeDateTime(value["dateStamp"]),
    mainLanguage: value["mainLanguage"],
    resourceType: value["resourceType"],
    contact:
      value["contact"] == null
        ? undefined
        : (value["contact"] as Array<any>).map(ContactInfoToJSON),
    cl_status:
      value["clStatus"] == null
        ? undefined
        : (value["clStatus"] as Array<any>).map(CodelistItemToJSON),
    cl_maintenanceAndUpdateFrequency:
      value["clMaintenanceAndUpdateFrequency"] == null
        ? undefined
        : (value["clMaintenanceAndUpdateFrequency"] as Array<any>).map(CodelistItemToJSON),
    cl_accessConstraints:
      value["clAccessConstraints"] == null
        ? undefined
        : (value["clAccessConstraints"] as Array<any>).map(CodelistItemToJSON),
    cl_classification:
      value["clClassification"] == null
        ? undefined
        : (value["clClassification"] as Array<any>).map(CodelistItemToJSON),
    cl_spatialRepresentationType:
      value["clSpatialRepresentationType"] == null
        ? undefined
        : (value["clSpatialRepresentationType"] as Array<any>).map(CodelistItemToJSON),
    cl_function:
      value["clFunction"] == null
        ? undefined
        : (value["clFunction"] as Array<any>).map(CodelistItemToJSON),
    resourceTitleObject: MultilingualStringToJSON(value["resourceTitleObject"]),
    resourceDate:
      value["resourceDate"] == null
        ? undefined
        : (value["resourceDate"] as Array<any>).map(ResourceDateToJSON),
    resourceTemporalDateRange:
      value["resourceTemporalDateRange"] == null
        ? undefined
        : (value["resourceTemporalDateRange"] as Array<any>).map(ResourceTemporalRangeToJSON),
    resourceIdentifier:
      value["resourceIdentifier"] == null
        ? undefined
        : (value["resourceIdentifier"] as Array<any>).map(ResourceIdentifierToJSON),
    resourceAbstractObject: MultilingualStringToJSON(value["resourceAbstractObject"]),
    cl_resourceCharacterSet:
      value["clResourceCharacterSet"] == null
        ? undefined
        : (value["clResourceCharacterSet"] as Array<any>).map(CodelistItemToJSON),
    contactForResource:
      value["contactForResource"] == null
        ? undefined
        : (value["contactForResource"] as Array<any>).map(ContactInfoToJSON),
    resourceLanguage: value["resourceLanguage"],
    allKeywords:
      value["allKeywords"] == null ? undefined : mapValues(value["allKeywords"], KeywordsToJSON),
    cl_topic:
      value["clTopic"] == null
        ? undefined
        : (value["clTopic"] as Array<any>).map(CodelistItemToJSON),
    resolutionScaleDenominator: value["resolutionScaleDenominator"],
    resolutionDistance: value["resolutionDistance"],
    licenseObject:
      value["licenseObject"] == null
        ? undefined
        : (value["licenseObject"] as Array<any>).map(MultilingualStringWithLinkToJSON),
    MD_ConstraintsUseLimitationObject:
      value["mDConstraintsUseLimitationObject"] == null
        ? undefined
        : (value["mDConstraintsUseLimitationObject"] as Array<any>).map(MultilingualStringToJSON),
    extentIdentifierObject:
      value["extentIdentifierObject"] == null
        ? undefined
        : (value["extentIdentifierObject"] as Array<any>).map(MultilingualStringToJSON),
    crsDetails:
      value["crsDetails"] == null
        ? undefined
        : (value["crsDetails"] as Array<any>).map(CrsDetailToJSON),
    specificationConformance:
      value["specificationConformance"] == null
        ? undefined
        : (value["specificationConformance"] as Array<any>).map(SpecificationConformanceToJSON),
    lineageObject: MultilingualStringToJSON(value["lineageObject"]),
    format: value["format"],
    contactForDistribution:
      value["contactForDistribution"] == null
        ? undefined
        : (value["contactForDistribution"] as Array<any>).map(ContactInfoToJSON),
    link: value["link"] == null ? undefined : (value["link"] as Array<any>).map(OnlineLinkToJSON),
    popularity: value["popularity"],
    logo: value["logo"],
    documentStandard: value["documentStandard"],
    isHarvested: value["isHarvested"],
    sourceCatalogue: value["sourceCatalogue"],
    overview:
      value["overview"] == null ? undefined : (value["overview"] as Array<any>).map(OverviewToJSON),
  };
}
